export default __webpack_public_path__ + "static/media/bol_scan_7.974f32e2.svg";